<template>
  <div class="fluid" id="componentList">
    <div>
      <div class="component-list-div">
        <v-card elevation="0" class="px-3 py-2" style="width: 100%">
          <v-row>
            <v-col
              cols="12"
              class="d-flex"
              style="
                position: relative;
                padding: 0 20px;
                text-align: center;
                margin-top: 20px;
              "
            >
              <h4 class="indigo--text" style="font-weight: bold; margin: auto">
                KOMPONEN PAYROLL
                <v-tooltip bottom color="grey">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      x-small
                      text
                      icon
                      color="grey darken-2"
                      @click="getDataFromApi"
                    >
                      <v-icon small>mdi-refresh</v-icon>
                    </v-btn>
                  </template>
                  <span>refresh page</span>
                </v-tooltip>
              </h4>
            </v-col>
            <v-col cols="12">
              <div>
                <v-toolbar
                  class="component-toolbar-1"
                  flat
                  style="
                    height: 60px;
                    border-radius: 10px 10px 0 0;
                    padding-top: 15px;
                  "
                >
                  <div class="d-flex align-content-start">
                    <div
                      style="margin-right: 15px; height: 45px"
                      class="d-flex justify-center align-center"
                    >
                      <v-btn
                        style="font-size: 12px"
                        @click="addComponent"
                        elevation="2"
                        tilerounded="5px"
                        color="primary"
                        class="white--text"
                        small
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" small class="">
                              mdi-plus
                            </v-icon>
                          </template>
                          <span>Tambah Konfigurasi</span>
                        </v-tooltip>
                      </v-btn>
                    </div>
                  </div>
                  <!-- <div style="width: 210px; height: 45px">
                    <v-autocomplete
                      v-model="paramAPI.company_id"
                      label="Perusa"
                      item-text="name"
                      item-value="id"
                      return-id
                      dense
                      outlined
                      clearable
                      @change="companyWatcher"
                      :items="dropdown.company"
                      :disabled="isDisableCompanyDropdown"
                    ></v-autocomplete>
                  </div> -->
                  <div style="width: 210px; height: 45px; margin-left: 10px">
                    <v-autocomplete
                      v-model="paramAPI.type"
                      label="Tipe"
                      item-text="name"
                      item-value="id"
                      return-id
                      dense
                      outlined
                      clearable
                      @change="categoryWatcher"
                      :items="dropdown.type"
                    ></v-autocomplete>
                  </div>
                  <div style="width: 210px; height: 45px; margin-left: 10px">
                    <v-autocomplete
                      v-model="paramAPI.cycle"
                      label="Siklus"
                      item-text="name"
                      item-value="id"
                      return-id
                      dense
                      outlined
                      clearable
                      @change="cycleWatcher"
                      :items="dropdown.cycle"
                    ></v-autocomplete>
                  </div>
                  <div style="width: 330px; height: 45px; margin-left: auto">
                    <v-text-field
                      v-model="paramAPI.keyword"
                      @keyup.enter="searchEnter"
                      label="Search here"
                      type="search"
                      append-icon="mdi-magnify"
                      outlined
                      dense
                    ></v-text-field>
                  </div>
                </v-toolbar>
              </div>
            </v-col>

            <v-col cols="12" style="width: 100%">
              <v-data-table
                v-if="result.length > 0 || !skeleton_loading"
                mobile-breakpoint="0"
                fixed-header
                height="60vh"
                :headers="headers"
                style="cursor: pointer"
                :items="result"
                :loading="loading"
                @click:row="rowClick"
                item-key="id"
                :options.sync="options"
                :footer-props="{
                  showFirstLastPage: true,
                  showCurrentPage: true,
                  itemsPerPageOptions: [1, 3, 5, 10, 15, 100]
                }"
                :server-items-length="totalData"
                :page="paramAPI.page"
                @update:page="updatePage"
                :items-per-page="paramAPI.itemsPerPage"
                @update:items-per-page="updateItemPerPage"
              >
                <template v-slot:[`item.no`]="{ index }">
                  <div
                    style="
                      font-size: 14px;
                      padding: 0;
                      display: flex;
                      flex-direction: row;
                    "
                  >
                    {{ index + 1 + paramAPI.offset * paramAPI.limit }}
                  </div>
                </template>
                <template v-slot:[`item.name`]="{ item }">
                  <div
                    style="
                      font-size: 12px;
                      padding: 0;
                      width: 150px;
                      display: flex;
                      flex-direction: row;
                      color: green;
                    "
                  >
                    {{ item.name }}
                  </div>
                </template>
                <template v-slot:[`item.status`]="{ item }">
                  <div
                    style="
                      font-size: 12px;
                      padding: 0;
                      width: 60px;
                      display: flex;
                      flex-direction: row;
                      color: green;
                    "
                  >
                    {{
                      item.status == 1
                        ? 'Active'
                        : item.status == 0
                        ? 'Inactive'
                        : '-'
                    }}
                  </div>
                </template>
                <template v-slot:[`item.type`]="{ item }">
                  <div
                    style="
                      font-size: 12px;
                      padding: 0;
                      width: 80px;
                      display: flex;
                      flex-direction: row;
                      color: green;
                    "
                  >
                    {{
                      item.type == 1
                        ? 'Kelonggaran'
                        : item.type == 2
                        ? 'Pengurangan'
                        : item.type == 3
                        ? 'Benefit'
                        : '-'
                    }}
                  </div>
                </template>
                <template v-slot:[`item.period`]="{ item }">
                  <div
                    style="
                      font-size: 12px;
                      padding: 0;
                      width: 80px;
                      display: flex;
                      flex-direction: row;
                      color: green;
                    "
                  >
                    {{
                      item.period == 1
                        ? 'Harian'
                        : item.period == 2
                        ? 'Bulanan'
                        : item.period == 3
                        ? 'Satu kali'
                        : '-'
                    }}
                  </div>
                </template>
                <template v-slot:[`item.is_taxable`]="{ item }">
                  <div
                    style="
                      font-size: 12px;
                      padding: 0;
                      width: 80px;
                      display: flex;
                      flex-direction: row;
                      color: green;
                    "
                  >
                    {{ item.is_taxable !== null ? item.is_taxable : '-' }}
                  </div>
                </template>
                <template v-slot:[`item.createdAt`]="{ item }">
                  <div
                    style="
                      font-size: 12px;
                      width: 80px;
                      padding: 0;
                      display: flex;
                      flex-direction: row;
                    "
                  >
                    {{ convertDate(item.createdAt) }}
                  </div>
                </template>
                <template v-slot:[`item.updatedAt`]="{ item }">
                  <div
                    style="
                      font-size: 12px;
                      width: 80px;
                      padding: 0;
                      display: flex;
                      flex-direction: row;
                    "
                  >
                    {{ convertDate(item.updatedAt) }}
                  </div>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }"
                      ><v-icon
                        v-bind="attrs"
                        v-on="on"
                        @click.stop="rowClick(item)"
                        small
                        color="primary"
                        class="mr-2"
                      >
                        mdi-pencil
                      </v-icon>
                    </template>
                    <span>Edit</span>
                  </v-tooltip>
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        small
                        color="error"
                        @click.stop="deleteItem(item)"
                      >
                        mdi-delete
                      </v-icon>
                    </template>
                    <span>Delete</span>
                  </v-tooltip>
                </template>
              </v-data-table>
              <v-skeleton-loader
                v-else
                style="width: 100%"
                type="table-heading, table-tbody, table-tfoot"
              ></v-skeleton-loader>
            </v-col>
          </v-row>
        </v-card>
      </div>
    </div>
    <v-dialog v-model="componentDialog" persistent max-width="500px">
      <v-card v-if="form !== null">
        <v-card-title>
          <span class="text-h5">Add/Edit Konfigurasi</span>
        </v-card-title>
        <v-form ref="entryForm2" @submit.prevent="saveComponent">
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Nama Komponen
                  </p>
                  <v-text-field
                    v-model="form.name"
                    :rules="rules.nameRules"
                    dense
                    outlined
                    style="height: 45px"
                  />
                </v-col>
                <v-col cols="12" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Tipe
                  </p>
                  <v-autocomplete
                    v-model="form.type"
                    :items="dropdown.type"
                    :rules="rules.typeRules"
                    item-text="name"
                    item-value="id"
                    return-id
                    dense
                    outlined
                    clearable
                    style="height: 45px"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="5" class="d-flex flex-column">
                  <v-col
                    cols="12"
                    style="
                      padding: 15px 0 0 0;
                      justify-content: flex-start;
                      align-items: center;
                      display: flex;
                    "
                  >
                    <p
                      style="margin: 0; font-size: 16px; color: rgb(85, 85, 85)"
                    >
                      Kena Pajak ?
                    </p>

                    <v-checkbox
                      v-model="form.is_taxable"
                      style="margin: 0 0 0 20px; height: 25px; padding: 0"
                    ></v-checkbox>
                  </v-col>
                </v-col>
                <v-col cols="7" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Siklus
                  </p>
                  <v-autocomplete
                    v-model="form.period"
                    item-text="name"
                    item-value="id"
                    return-id
                    dense
                    outlined
                    clearable
                    :items="dropdown.cycle"
                    :rules="rules.cycleRules"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeComponentDialog">
              Close
            </v-btn>
            <v-btn color="blue darken-1" text type="submit"> Save </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters, mapMutations /*  mapActions */ } from 'vuex'
import buildType from '../../../../services/buildType'
export default {
  name: 'mspayrollcomponent',
  data: () => ({
    editDialog: false,
    componentDialog: false,
    eSanqua: buildType.apiURL('esanqua'),
    hrsApi: buildType.apiURL('hrs'),
    build: process.env.VUE_APP_BUILD_TYPE,
    paramAPI: {
      page: 1,
      keyword: '',
      offset: 0,
      limit: 10,
      itemsPerPage: 10,
      sortBy: 'date',
      sortType: 'desc',
      company_id: null,
      type: null,
      cycle: null
      // department_id: null
    },
    totalData: 0,
    form: null,
    detail: null,
    isEdit: false,

    options: {},
    actionValue: 0,
    headers: [
      {
        text: 'No',
        value: 'no',
        align: 'left',
        sortable: false
      },
      {
        text: 'Nama',
        value: 'name',
        align: 'left',
        sortable: false
      },
      {
        text: 'Tipe',
        value: 'type',
        align: 'left',
        sortable: false
      },
      {
        text: 'Kena Pajak',
        value: 'is_taxable',
        align: 'left',
        sortable: false
      },
      {
        text: 'Siklus',
        value: 'period',
        align: 'left',
        sortable: false
      },
      // {
      //   text: 'Perusahaan',
      //   value: 'company_name',
      //   align: 'left',
      //   sortable: false
      // },
      {
        text: 'Status',
        value: 'status',
        align: 'left',
        sortable: false
      },
      {
        text: 'Dibuat pada',
        value: 'createdAt',
        align: 'left',
        sortable: false
      },
      {
        text: 'Actions',
        value: 'action',
        align: 'left',
        sortable: false
      }
    ],
    result: [],
    loading: false,
    isDisableCompanyDropdown: false,
    rules: {
      taxRules: [],
      typeRules: [],
      nameRules: [],
      cycleRules: []
    },
    dropdown: {
      company: [],
      type: [
        {
          id: 1,
          name: 'Kelonggaran'
        },
        {
          id: 2,
          name: 'Pengurangan'
        },
        {
          id: 3,
          name: 'Benefit'
        }
      ],
      cycle: [
        {
          id: 1,
          name: 'Harian'
        },
        {
          id: 2,
          name: 'Bulanan'
        },
        {
          id: 3,
          name: 'Satu kali'
        }
      ]
    },
    skeleton_loading: true
  }),

  async mounted() {
    this.paramAPI.company_id = Number(
      this.getUserProfile.employee.company.plant_id
    )
    this.paramAPI.department_id = this.getUserProfile.employee.department_id

    if (this.getPayrollComponentPageQuery !== null) {
      this.paramAPI = this.getPayrollComponentPageQuery
    }
    setTimeout(async () => {
      await this.getDataFromApi()
      await this.initDropdown()
    }, 200)
  },
  computed: {
    // , 'getDropdownPlant'
    ...mapGetters(['getUserProfile', 'getPayrollComponentPageQuery'])
  },
  watch: {},
  methods: {
    // ...mapActions(['dropdownPlant']),
    ...mapMutations(['setPayrollComponentPageQuery']),
    showMsgDialog(pModalType, pStatusMsg, pBtnCancel) {
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html: '<strong style="font-size:18px;">' + pStatusMsg + '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            cancelButtonText: 'No'
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    async initDropdown() {
      this.dropdownCompany()
    },
    resetSomeParam() {
      this.paramAPI.limit = this.paramAPI.itemsPerPage
      this.paramAPI.offset = 0
      this.paramAPI.page = 1
    },
    searchEnter() {
      this.resetSomeParam()
      this.getDataFromApi()
    },
    // companyWatcher() {
    //   this.getDataFromApi()
    // },
    categoryWatcher() {
      this.resetSomeParam()
      this.getDataFromApi()
    },
    cycleWatcher() {
      this.resetSomeParam()
      this.getDataFromApi()
    },

    async dropdownCompany() {
      const level = this.getUserProfile.level.find(
        ({ id }) => id === '1' || id === '39'
      )
      let xFlag = false
      if (level !== undefined) {
        if (level.user_user_level !== null) {
          if (
            level.user_user_level.allowed_company === null ||
            level.user_user_level.allowed_company.length === 0
          ) {
            xFlag = true
          } else {
            this.dropdown.company = level.user_user_level.allowed_company
            this.isDisableCompanyDropdown = false
          }
        } else {
          xFlag = true
        }
      } else {
        xFlag = true
      }

      if (xFlag) {
        if (Number(this.getUserProfile.employee.company.plant_id) !== 6) {
          this.isDisableCompanyDropdown = true
        } else {
          this.isDisableCompanyDropdown = false
        }
        axios
          .get(`${this.eSanqua}master/universal/plant/dropdown`)
          .then((res) => {
            this.dropdown.company = res.data.data
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },

    async getDataFromApi() {
      this.loading = true
      await this.initDataTable()
        .then((data) => {
          if (data.status_code === '00') {
            this.totalData = data.total_record
            return (this.result = data.data)
          }
          return (this.result = [])
        })
        .catch((err) => {
          console.log(err)
          return (this.result = [])
        })
      this.skeleton_loading = false
      this.loading = false
    },
    async initDataTable() {
      let url = `${this.hrsApi}master/universal/payrollcomponent/list?keyword=${
        this.paramAPI.keyword
      }&offset=${this.paramAPI.offset * this.paramAPI.limit}&limit=${
        this.paramAPI.limit
      }&join_table=`
      const filter = []
      if (this.paramAPI.type != undefined && this.paramAPI.type != null) {
        filter.push(`{"type": ${this.paramAPI.type}}`)
      }
      if (this.paramAPI.cycle != undefined && this.paramAPI.cycle != null) {
        filter.push(`{"period": ${this.paramAPI.cycle}}`)
      }
      url = url + `&filter=[${filter}]`
      console.log('url>>>', url)
      console.log('param>>>', this.paramAPI)
      this.setPayrollComponentPageQuery(this.paramAPI)
      return await new Promise((resolve) => {
        axios
          .get(url)
          .then((res) => {
            console.log(res)
            resolve(res.data)
          })
          .catch((err) => {
            console.log(err)
          })
      })
    },
    enableEdit() {
      var oldForm = this.form
      this.isEdit = !this.isEdit
      if (!this.isEdit) {
        this.form = oldForm
        if (this.form.act === 'add') {
          this.closeDialog()
        }
      }
    },

    rowClick(pItem) {
      this.form = {
        act: 'update',
        id: pItem.id,
        is_taxable: pItem.is_taxable,
        period: pItem.period,
        name: pItem.name,
        type: pItem.type
      }
      setTimeout(() => {
        this.componentDialog = !this.componentDialog
      }, 300)
    },
    async deleteItem(pItem) {
      this.showMsgDialog(
        'question',
        'Are you sure, This data will be deleted permanently',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          await axios
            .delete(
              `${this.hrsApi}master/universal/payrollcomponent/delete/${pItem.id}`
            )
            .then(async (res) => {
              if (res.data.status_code !== '-99') {
                this.showMsgDialog('success', res.data.status_msg, false)
                this.getDataFromApi()
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
            })
            .catch((err) => {
              console.log(err)
              this.showMsgDialog(
                'error',
                err
                  ? 'Something went wrong, Please contact an admin!'
                  : 'Something went wrong, Please contact an admin!',
                false
              )
            })
        }
      })
    },
    closeDialog() {
      this.form = null
      this.isEdit = false
      setTimeout(() => {
        this.editDialog = false
      }, 300)
    },
    addComponent() {
      this.form = {
        act: 'add',
        name: '',
        is_taxable: false,
        period: false,
        type: null
      }
      setTimeout(() => {
        this.componentDialog = !this.componentDialog
      }, 300)
    },
    saveComponent() {
      this.rules.cycleRules = [(v) => !!v || 'Siklus wajib diisi']
      this.rules.nameRules = [(v) => !!v || 'Nama wajib diisi']
      this.rules.typeRules = [(v) => !!v || 'Tipe wajib diisi']
      this.rules.taxRules = [(v) => !!v || 'Kena pajak wajib diisi']
      const self = this
      setTimeout(function () {
        if (self.$refs.entryForm2.validate()) {
          console.log(self.form)
          const form = {
            act: self.form.act,
            name: self.form.name,
            // company_id: self.form.company.id,
            // company_name: self.form.company.name,
            is_taxable: self.form.is_taxable,
            period: self.form.period,
            type: self.form.type
          }
          if (form.act === 'update') {
            Object.assign(form, { id: self.form.id })
          }
          console.log(form)
          self.submitComponent(form)
        }
      })
    },
    async submitComponent(form) {
      await axios
        .post(`${this.hrsApi}master/universal/payrollcomponent/save`, form)
        .then(async (res) => {
          console.log(res.data)
          if (res.data.status_code !== '-99') {
            this.showMsgDialog('success', res.data.status_msg, false)
            this.getDataFromApi()
            this.closeComponentDialog()
          } else {
            if (res.data.status_msg === 'Parameter value has problem') {
              this.showMsgDialog(
                'warning',
                'Invalid input, Parameter value has problem',
                false
              )
            } else {
              this.showMsgDialog('warning', res.data.status_msg, false)
            }
          }
        })
        .catch((err) => {
          console.log(err)
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
        })
    },
    closeComponentDialog() {
      this.componentDialog = false
      setTimeout(() => {
        this.form = null
      }, 300)
    },
    async updatePage(p) {
      this.paramAPI.page = p
      this.paramAPI.offset = p - 1
      await this.getDataFromApi()
    },
    async updateItemPerPage(p) {
      this.paramAPI.itemsPerPage = p
      this.paramAPI.limit = p
      this.paramAPI.offset = 0
      await this.getDataFromApi()
    },
    convertDate(raw) {
      if (raw !== null) {
        const date = new Date(raw)
        const local = date.toLocaleString('id')
        return local
      } else {
        return '-'
      }
    }
  }
}
</script>
<style lang="scss">
#componentList {
  position: relative;
  .component-list-div {
    padding: 15px;
    min-height: 50vh;
    display: flex;
    justify-content: center;
    align-items: center;

    .component-toolbar-1 {
      .component-toolbar-1 {
        width: 60%;
        display: flex;
        flex-direction: row;
        margin-left: auto;
      }
    }
    .activity-list-toolbar-2 {
      display: none;
    }
  }
}

@media (max-width: 768px) {
  #componentList {
    .component-list-div {
      .component-toolbar-1 {
        .component-toolbar-1 {
          display: none;
        }
      }
      .activity-list-toolbar-2 {
        display: block;
      }
    }
  }
}
</style>
